<section class="about-section about-illustration-img section-gap">
    <div class="container">
        <div class="illustration-img">
            <img src="assets/img/ImgSection2.png" alt="img">
        </div>
        <div class="row no-gutters justify-content-lg-end justify-content-center">
            <div class="col-lg-6 col-md-10">
                <div class="about-text">
                    <div class="section-title left-border mb-40">
                        <h2 class="titleSection2">La Asociación Angus <br> Mexicana Presenta: </h2>
                    </div>
                    <ul class="about-list">
                        <li> <i class="far fa-check"></i> Una certificación privada para productores mexicanos.</li>
                        <li> <i class="far fa-check"></i> Normativamente fuerte y robusta.</li>
                        <li> <i class="far fa-check"></i> De pura genética Angus.</li>
                    </ul>
                    <a routerLink="/faqs" class="main-btn main-btn-4">Policy</a>
                </div>
            </div>
        </div>
    </div>
    <section id='Estandar'></section>
</section>
